import React from 'react'

interface Tile {
	label: string
	value: string
	hint?: string
	active?: boolean
	onClick?: () => void
}

/** Figures across the top of a planning report. A tile with onClick works as a filter. */
export const PlanningTiles: React.FC<{ tiles: Tile[] }> = ({ tiles }) => (
	<div className='row mb-2'>
		{tiles.map((tile) => (
			<div className='col-lg-2 col-md-4 col-6 mb-2' key={tile.label}>
				<div
					className={`border rounded p-3 h-100 ${tile.active ? 'border-primary bg-light-primary' : 'bg-white'}`}
					style={tile.onClick ? { cursor: 'pointer' } : undefined}
					onClick={tile.onClick}
					title={tile.hint}
				>
					<div className='text-muted small'>{tile.label}</div>
					<div className='fs-4 fw-bolder'>{tile.value}</div>
				</div>
			</div>
		))}
	</div>
)

/** What a report shows instead of its table: the errors, the spinner, or why it is empty. */
export const PlanningNotice: React.FC<{ loading: boolean; errors: string[]; hasData: boolean; empty?: string }> = ({ loading, errors, hasData, empty }) => {
	if (errors.length > 0) {
		return (
			<div className='alert alert-danger py-3'>
				{errors.map((error) => <div key={error}>{error}</div>)}
			</div>
		)
	}
	if (loading && !hasData) {
		return (
			<div className='text-center text-muted py-10'>
				<span className='spinner-border spinner-border-sm me-2'></span>Loading...
			</div>
		)
	}
	if (!hasData) {
		return <div className='text-center text-muted py-10'>{empty || 'Choose a project and click "View".'}</div>
	}
	return null
}

/** Product name with its code, and a mark when the product is inactive. */
export const ProductName: React.FC<{ row: { productName: string; productCode?: string | null; status?: string | null } }> = ({ row }) => (
	<>
		{row.productName}
		{row.productCode ? <span className='text-muted'> ({row.productCode})</span> : null}
		{row.status === 'Inactive' ? <span className='badge badge-light-dark ms-1'>Inactive</span> : null}
	</>
)
